import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import * as routes from '@configs/routes.json';
import logo from '@assets/images/adaptive-logo.svg';
import './Header.scss';

export interface IHeaderStateProps {
  email?: string;
  isAuthenticated: boolean;
  brandImage?: string;
}

export interface IHeaderDispatchProps {
  logOut: () => void;
}

const Header: React.FC<IHeaderStateProps & IHeaderDispatchProps> = ({
  email,
  isAuthenticated,
  brandImage,
  logOut,
}) => {
  const { t } = useTranslation();

  return (
    <div className='header'>
      <div className='container'>
        <div className='row'>
          <div className='col-4 fcolor--grey-border font-family-heading font-size-18 product-title'>
            {brandImage && (
              <span className='custom-brand-logo'>
                <img src={brandImage} alt='Brand Logo' />
              </span>
            )}
            {isAuthenticated && t('title')}
          </div>
          <div className='col-4 text-center logo'>
            <NavLink to={routes.app.login}>
              <img src={logo} alt='Logo' />
            </NavLink>
          </div>
          {isAuthenticated && (
            <div className='col-4 text-right sign-out'>
              <div onClick={() => logOut()}>{t('header_signOut')}</div>
              <div title={email}>{email}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
